if(!customElements.get('main-article')) {
  class MainArticle extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      this.setupHeaderScroll();
    }
  
    setupHeaderScroll() {
      const title = this.querySelector(".scroll-title");
  
      window.addEventListener("scroll", () => {
        const scrollY = window.scrollY || window.pageYOffset;
  
        title.classList.toggle("active", scrollY >= 180);
      });
    }
  }
  
  customElements.define("main-article", MainArticle);
}
